export default __webpack_public_path__ + "static/6873-44bbbe009c1bfaee77fa4cdbbf0c7f14.jpg";